import _asyncToGenerator from "/neworiental/jenkins/workspace/seal-remixed-troy-student-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import iframeServer from '@/views/iframe-server/index';
export default {
  name: 'VideoIframe',
  components: {
    iframeServer: iframeServer
  },
  props: {
    showDialog: {
      type: Boolean
    },
    dialogTitle: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    isFirstEnter: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      dialogVisible: this.showDialog,
      iframeUrl: '',
      dialogHeight: '',
      conutdown: 0,
      showCloseBtn: false,
      isFullScreen: false,
      dialogScrollTop: false // 如果是加载视频，超过一屏幕了，让弹框吸顶

    };
  },
  computed: {
    notTopDialog: function notTopDialog() {
      return this.dialogScrollTop ? 'dialog-scrollTop' : '';
    }
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _this$$refs$myDialog, _this$$refs$myDialog2;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              window.addEventListener('message', _this.videoUpdated);
              window.addEventListener('resize', _this.setDialogScrollTop);
              _this.iframeUrl = _this.url;
              _context.next = 5;
              return _this.$nextTick();

            case 5:
              _this.dialogHeight = _this === null || _this === void 0 ? void 0 : (_this$$refs$myDialog = _this.$refs.myDialog) === null || _this$$refs$myDialog === void 0 ? void 0 : _this$$refs$myDialog.$refs.dialog.offsetHeight;
              _this.dialogScrollTop = (_this === null || _this === void 0 ? void 0 : (_this$$refs$myDialog2 = _this.$refs.myDialog) === null || _this$$refs$myDialog2 === void 0 ? void 0 : _this$$refs$myDialog2.$refs.dialog.offsetHeight) > document.body.clientHeight;

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  // 组件销毁时注销掉播放器
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('message', this.videoUpdated);
  },
  methods: {
    videoUpdated: function videoUpdated(e) {
      var _e$data, _e$data2, _e$data3, _e$data4;

      console.log(e);
      if (!((_e$data = e.data) !== null && _e$data !== void 0 && _e$data.eventName)) return;

      if (((_e$data2 = e.data) === null || _e$data2 === void 0 ? void 0 : _e$data2.eventName) === 'videoLoaded') {
        if (this.isFirstEnter) {
          this.conutdown = 31;
          this.settime();
        }
      }

      if (((_e$data3 = e.data) === null || _e$data3 === void 0 ? void 0 : _e$data3.eventName) === 'videoLoadError') {
        if (this.isFirstEnter) {
          this.showCloseBtn = true;
        }
      }

      if (((_e$data4 = e.data) === null || _e$data4 === void 0 ? void 0 : _e$data4.eventName) === 'setFullScreen') {
        var _e$data5;

        this.isFullScreen = (_e$data5 = e.data) === null || _e$data5 === void 0 ? void 0 : _e$data5.fullScreen;
      }
    },
    setDialogScrollTop: function setDialogScrollTop() {
      var _this$$refs$myDialog3, _this$$refs$myDialog4;

      this.dialogHeight = this === null || this === void 0 ? void 0 : (_this$$refs$myDialog3 = this.$refs.myDialog) === null || _this$$refs$myDialog3 === void 0 ? void 0 : _this$$refs$myDialog3.$refs.dialog.offsetHeight;
      this.dialogScrollTop = (this === null || this === void 0 ? void 0 : (_this$$refs$myDialog4 = this.$refs.myDialog) === null || _this$$refs$myDialog4 === void 0 ? void 0 : _this$$refs$myDialog4.$refs.dialog.offsetHeight) > document.body.clientHeight;
    },
    handleClose: function handleClose(data) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this2.$emit('update:showDialog', false);

                if (_this2.isFirstEnter) {
                  _this2.$store.dispatch('setShowPageCue', true);
                }

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    settime: function settime() {
      var _this3 = this;

      var timer = null;

      if (this.conutdown === 0) {
        clearTimeout(timer);
        this.showCloseBtn = true;
      } else {
        this.conutdown--;
        timer = setTimeout(function () {
          _this3.settime();
        }, 1000);
      }
    }
  }
};